import React from "react";
import SignUpLayer from "../components/SignUpLayer";

const SignUp = () => {
  return (
    <>
      {/* SignUpLayer */}
      <SignUpLayer />
    </>
  );
};

export default SignUp;
